"use client";
import { createContext, useContext } from "react";
import type { ThemeDefinition } from "@/lib/themes";
import { themes } from "@/lib/themes";

export const ThemeContext = createContext<ThemeDefinition>(themes.maison);

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ theme, children }: { theme: ThemeDefinition; children: React.ReactNode; }) {
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
}
